import dynamic from 'next/dynamic';

export const Form = dynamic(() => import('./Form'), { ssr: true });
export const Slider = dynamic(() => import('./Slider'), { ssr: true });
